import React, { FunctionComponent, ReactNode } from 'react';

import UserflowTheme from '@lt/components/themes/userflow';

import { ConstructorContextProvider } from './constructorContext';
import { WidgetConstructor } from '../components/WidgetConstructor';
import { ApiContextProvider } from './apiContext';
import { WidgetDataContextProvider } from './widgetDataContext';

import type { WidgetSettingsConstructorParams } from './constructorContext/types';
import { Configurations } from 'src/models';

import '../styles/base.css';

type Props = {
  children?: ReactNode;
  constructorConfig?: Partial<WidgetSettingsConstructorParams>;
  config?: Configurations;
  onWidgetSettingsChange?: React.Dispatch<
    React.SetStateAction<{
      [k: string]: unknown;
    }>
  >;
  /** базовое состояние для виджета, удобно для отладки */
  initialState?: unknown;
  isOnPage?: boolean;
};

/* задаем базовые стили, до того как стили задаст styled-compnents
  чтобы при конфликте стилей выше специфичность была у компонентов */
const ContainerStyles = {
  display: 'flex',
  justifyСontent: 'space-around',
  alignItems: 'center',
  gap: '50px',
  padding: '50px',
};

const onPageStyles = {
  margin: '50px 0 50px',
};

const WidgetStyles = {
  width: '100%',
  textAlign: 'left' as const,
};

export const AppContext: FunctionComponent<Props> = ({
  children,
  constructorConfig,
  config,
  onWidgetSettingsChange,
  initialState,
  isOnPage = false,
}) => {
  const constructorValues = constructorConfig
    ? Object.keys(constructorConfig).reduce((res, cur) => {
        res[cur] = constructorConfig[cur].value;
        return res;
      }, {})
    : {};

  const configValues = {
    ...config,
    ...constructorValues,
  };

  return (
    <ConstructorContextProvider config={configValues}>
      <ApiContextProvider apiDomain={configValues.apiDomain}>
        <WidgetDataContextProvider initialState={initialState}>
          {/* задаем базовые стили, до того как стили задаст styled-compnents
            чтобы при конфликте стилей выше специфичность была у компонентов */}
          <div className="LTWidgetRoot">
            <UserflowTheme>
              <div style={isOnPage ? onPageStyles : ContainerStyles}>
                <div style={{ ...WidgetStyles, ...(onPageStyles && { minWidth: '0' }) }}>
                  {children}
                </div>
                {constructorConfig && onWidgetSettingsChange ? (
                  <WidgetConstructor
                    config={constructorConfig}
                    onWidgetSettingsChange={onWidgetSettingsChange}
                  />
                ) : null}
              </div>
            </UserflowTheme>
          </div>
        </WidgetDataContextProvider>
      </ApiContextProvider>
    </ConstructorContextProvider>
  );
};

// const Container = styled.div`
//   display: flex;
//   justify-content: space-around;
//   align-items: center;
//   gap: 50px;
//   padding: 50px;

//   & > * {
//     min-width: 0;
//   }
// `;

// const WidgetContainer = styled.div`
//   width: 100%;
// `;
